import * as React from "react";

import {faCaretDown}     from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {cx}              from "emotion";

import "./clearable-select.scss";

import {cs}       from "@Common/react/chain-services";
import {Dropdown} from "@Common/ui-components/dropdown/dropdown";
import {Types}    from "@Common/types";

export const ClearableSelect = <Item,>({
    list,
    placeholder,
    disabled=false,
    getExpandLabel=v=>String(v),
    getToggleLabel=v=>v,
    isSelected=()=>false,
    onSelect,
    onClear,
    xdQaName=undefined,
    style=undefined,
    captureOutsideClicks=true, // Use this if select is inside modal, if outside modal, don't use, it will be more natural
    loading=undefined,
    autoWidth=false,
    ...props
}:Types.Utils.Merge<React.HTMLProps<HTMLDivElement>, {
    autoWidth              ?: boolean,
    captureOutsideClicks   ?: boolean,
    disabled               ?: boolean,
    getExpandLabel         ?: (item:Item) => string,
    getToggleLabel         ?: (item:Item) => React.ReactNode,
    isSelected             ?: (item:Item) => boolean,
    list                    : Item[],
    loading                ?: boolean,
    onClear                 : () => void,
    onSelect                : (item:Item) => void,
    placeholder             : React.ReactNode,
    style                  ?: {color?: string, size?: string},
    xdQaName               ?: string,
}>) => cs(
    ["selectedItem", (_, next) => next(list?.find(isSelected))],
    ({selectedItem}) => Dropdown({
        forcedExpandBottom: true,
        forcedExpandLeft: true,
        renderToggle: ({domRef, showExpand, showingExpand}) => (
            <div
                {...props}
                className={cx("clearable-select-3j0 toggle", style?.size, style?.color)}
                ref={domRef}
            >
                <div
                    className="label" 
                    xd-qa-type="dropdown" 
                    xd-qa-name={xdQaName}
                    onClick={() => !disabled && showExpand()}
                >
                    {!selectedItem ? placeholder : getToggleLabel(selectedItem)}
                </div>
                <div className="right">
                    {selectedItem && (
                        <button 
                            className="clear" 
                            xd-qa-type="button" 
                            xd-qa-name={xdQaName + "dropdown clear"}
                            onClick={onClear}
                        >
                            Clear
                        </button>
                    )}
                    <div 
                        className="dropdown-indicator"
                        onClick={() => !disabled && showExpand()}
                    >
                        {<FontAwesomeIcon
                            className="caret" 
                            icon={faCaretDown}
                            flip={showingExpand ? "vertical" : null}
                        />}
                    </div>
                </div>
            </div>
        ),
        renderExpand: ({close, width, position, domRef}) => (
            <div
                className={cx("clearable-select-3j0 expand", {capture: captureOutsideClicks})}
                onClick={close}
                ref={domRef}
            >
                <div
                    className={"box"}
                    style={{...position, width: autoWidth ? undefined : width}}
                    onClick={(e) => e.stopPropagation()}
                >
                    {list?.map((item, i) => (
                        <div
                            className="item"
                            key={i}
                            onClick={() => {
                                onSelect(item);
                                close();
                            }}
                            xd-qa-type="dropdown_item"
                            xd-qa-name={xdQaName + " " + getExpandLabel(item)}
                        >
                            <div className="label">
                                {getExpandLabel(item)}
                            </div>
                        </div>
                    ))}
                    {loading && (
                        <div className="loading" xd-qa-type="label" xd-qa-name="Loading">
                            Loading...
                        </div>
                    )}
                </div>
            </div>
        ),
    })
);

